(() => {
function mount() {
const form = document.getElementById('ARMCartForm');
if (!form || form.dataset.quantityReady) return;
form.dataset.quantityReady = 'true';
const inputs = [...form.querySelectorAll('[data-arm-cart-quantity]')];
const status = form.querySelector('[data-arm-cart-status]');
const checkout = form.querySelector('[data-arm-cart-checkout]');
let busy = false;
let checkoutRequested = false;
function finish() {
if (checkoutRequested) window.location.assign(checkout.href);
else window.location.reload();
}
async function save(event, proceed = false) {
if (event) event.preventDefault();
if (!form.reportValidity()) return;
if (proceed) checkoutRequested = true;
if (busy) return;
const changes = inputs.map((input, index) => ({line: index + 1, quantity: Number(input.value), original: Number(input.dataset.originalQuantity)})).filter(item => item.quantity !== item.original).reverse();
const note = form.querySelector('[name="note"]').value;
if (!changes.length && note === form.dataset.originalNote) {
if (checkoutRequested) finish();
return;
}
busy = true;
form.setAttribute('aria-busy', 'true');
status.hidden = false;
status.textContent = form.dataset.saving;
const buttons = [...form.querySelectorAll('button')];
buttons.forEach(button => button.disabled = true);
inputs.forEach(input => input.disabled = true);
async function post(url, body) {
const response = await fetch(url, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(body)});
const result = await response.json();
if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || form.dataset.error);
return result;
}
try {
for (const change of changes) await post(form.dataset.changeUrl, {line: change.line, quantity: change.quantity});
if (note !== form.dataset.originalNote) await post(form.dataset.updateUrl, {note});
finish();
} catch (error) {
status.textContent = error.message || form.dataset.error;
status.setAttribute('role', 'alert');
busy = false;
checkoutRequested = false;
form.removeAttribute('aria-busy');
buttons.forEach(button => button.disabled = false);
inputs.forEach(input => input.disabled = false);
}
}
inputs.forEach(input => input.addEventListener('change', event => save(event)));
if (checkout) checkout.addEventListener('click', event => save(event, true));
form.addEventListener('submit', event => save(event));
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
else mount();
document.addEventListener('shopify:section:load', mount);
})();